// Trwały widok podziękowania po udanej płatności (Faza checkout UX).
// Sterowany stanem z Landing: PaymentReturnHandler wykrywa server-verified `paid`
// i podnosi stan, który otwiera ten modal. Zastępuje ulotny-tylko toast trwałym
// potwierdzeniem z jasnym next-step (zaproszenie na Telegram).
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { CheckCircle2, Send } from "lucide-react";
import { useT } from "../lib/i18n";

export default function ThankYouModal({ open, onOpenChange }) {
  const { t } = useT();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="thankyou-modal" className="max-w-md bg-[#F8F5F2] border border-[#E2D8CF] rounded-none p-0 overflow-y-auto max-h-[90vh]">
        <div className="bg-[#6E1A24] text-[#F8F5F2] px-6 py-6 flex items-center gap-3">
          <CheckCircle2 className="w-8 h-8 shrink-0" />
          <DialogHeader className="space-y-1 text-left">
            <DialogTitle className="font-display uppercase tracking-wide text-2xl">{t("thankyou.title")}</DialogTitle>
            <DialogDescription className="text-[#F8F5F2]/80 text-sm">{t("thankyou.subtitle")}</DialogDescription>
          </DialogHeader>
        </div>

        <div className="px-6 py-6 space-y-5">
          <p className="text-ink2 text-sm leading-relaxed">{t("thankyou.body")}</p>

          <div className="bg-[#F2EBE5] border border-[#E2D8CF] p-4 flex items-start gap-3">
            <Send className="w-5 h-5 text-[#6E1A24] mt-0.5 shrink-0" />
            <p className="text-sm text-ink2 leading-relaxed">{t("thankyou.next_tg")}</p>
          </div>

          <button
            type="button"
            onClick={() => onOpenChange(false)}
            data-testid="thankyou-close-btn"
            className="btn-primary w-full px-8 py-4 inline-flex items-center justify-center gap-2"
          >
            {t("thankyou.close")}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
